import React, {useState} from 'react';
import ActionModal from "./ActionModal";
import useMyTranslation from "../../../Hooks/useMyTranslation";
import {FormControl, FormGroup, FormLabel, FormSelect} from "react-bootstrap";
import {displayNameForLanguageCode} from "../../../utils/utils";
import {useTranslation} from "react-i18next";
import {subscribeToGlobalNotifications, subscribeToNotificationsForCompany} from "../../../API/companyApi";

const AddNotificationSubscriberModal = ({companyId, active, hide, onSuccess}) => {
    const t = useMyTranslation('pages.settings.addSubscriberDialog')
    const {t: tOrig} = useTranslation()

    const [email, setEmail] = useState('');
    const [langCode, setLangCode] = useState('en');
    const [label, setLabel] = useState('');

    async function addSubscriber() {
        const subscriber = {
            recipient: email,
            language: langCode,
            label: label.length > 0 ? label : null
        }

        if (companyId)
        {
            await subscribeToNotificationsForCompany(companyId, subscriber);
        }
        else {
            await subscribeToGlobalNotifications(subscriber);
        }

        setEmail('');
        setLangCode('en');
        setLabel('');
    }

    const availableLanguages = ['en', 'nl']

    function validate() {
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            return [false, t("invalidEmail")]
        }

        return [true, ''];
    }

    return (
        <div>
            <ActionModal
                func={addSubscriber}
                active={active}
                hideOnConfirm
                onCancel={hide}
                onConfirm={onSuccess}
                validator={validate}
                title={t("title")}>

                <FormGroup>
                    <FormLabel>Email</FormLabel>
                    <FormControl type='email' placeholder={"example@gmail.com"} value={email}
                                 onChange={(e) => setEmail(e.target.value)}/>
                </FormGroup>
                <FormGroup className={'mt-2'}>
                    <FormLabel>Language</FormLabel>
                    <FormSelect
                        value={langCode}
                        onChange={(e) => setLangCode(e.target.value)}>
                        {availableLanguages.map((lngCode) => (
                            <option key={lngCode} value={lngCode}>
                                {displayNameForLanguageCode(lngCode, tOrig)}
                            </option>
                        ))}
                    </FormSelect>
                </FormGroup>
                <FormGroup className={'mt-2'}>
                    <FormLabel>Label</FormLabel>
                    <FormControl type='text' placeholder={t("optionalLabel")} value={label}
                                 onChange={(e) => setLabel(e.target.value)}/>
                </FormGroup>
            </ActionModal>
        </div>
    );
};

export default AddNotificationSubscriberModal;